export function findMobileBuildNumber(): number | undefined {
  return undefined;
}
